import PropTypes from 'prop-types';

import { PRODUCTS_LAST_VIEWED_LIMIT } from '@/common/constants';
import {
  ClassNameDefaultProps,
  ClassNamePropTypes,
} from '@/common/proptypes/Base/ClassName.protypes';

export const PushLastViewDefaultProps = {
  ...ClassNameDefaultProps,
  limit: PRODUCTS_LAST_VIEWED_LIMIT,
  refetchCart: () => null,
};

export const PushLastViewPropTypes = {
  ...ClassNamePropTypes,
  limit: PropTypes.number,
  refetchCart: PropTypes.func,
};
